export const NAV = [
  { id: 'workspace', label: 'Brain' },
  { id: 'people', label: 'People' },
  { id: 'plan', label: 'Plan' },
  { id: 'files', label: 'Files' },
  { id: 'notifications', label: 'Notifications' },
  { id: 'preferences', label: 'Preferences' },
];

export const DEFAULT_PREFERENCES = {
  trackpadPanSensitivity: 1.0,
  trackpadZoomSensitivity: 1.0,
  autoArchiveEnabled: true,
  autoArchiveDays: 7,
  desktopNotifications: true,
};
